namespace GeniuzPOS.ReportMasterData {
    export interface Report_1314Form {
    }

    export class Report_1314Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1314';
    }
}
